import { Stack, Typography } from '@mui/material'
import TextBox from '../../components/TextBox'
import React, { useState } from 'react'
import { AccountBox, AccountTree, Add, Edit, Mail, Phone } from '@mui/icons-material'
import CustomAutoComplete from '../../components/CustomAutoComplete'
import ButtonSubmit from '../../components/ButtonSubmit'
import { useNavigate, useLocation } from 'react-router-dom'
import API from '../../services/api'
import CustomSnackBar from '../../components/CustomSnackBar'
import ButtonBack from '../../components/ButtonBack'
import MainText from '../../components/MainText'

export default function EditExecutive() {
  const navigate = useNavigate();
  const location = useLocation();
  
  const executiveData = location.state || {};
  
  const [loading, setLoading] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("info");

  const [formData, setFormData] = useState({
    name: executiveData.name || "",
    lastName: executiveData.lastName || "",
    phone: executiveData.phone || 0,
    role: executiveData.role || "",
    email: executiveData.email || "",
    supplier_id: executiveData.supplier || 0,
  });
console.log('data:', executiveData)
  const handleChange = (name, value) => {
    setFormData(prev => ({
      ...prev, [name]: value
    }));
    console.log(formData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await API.patch(`/executive/${executiveData.id}/`, formData);
      setOpenSnack(true);
      setSnackMessage("¡Actualizado con éxito!");
      setSnackSeverity("success");
      setTimeout(() => {
        setLoading(false);
        navigate('/suppliers/executive/all-executives');
      }, 1500);
    } catch (error) {
      setOpenSnack(true);
      console.log(error);
      setSnackMessage("Algo salió mal, intente de nuevo");
      setSnackSeverity("error");
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
 <MainText
 title={'Editar ejecutivo'}
 icon={Edit}
 />
      <TextBox
        label='Nombre/s'
        icon={AccountBox}
        required
        minLength={0}
        maxLength={20}
        name={'name'}
        errorMessage='Campo requerido'
        onChange={handleChange}
        type='text'
        newValue={formData.name}
      />
      <TextBox
        label='Apellido/s'
        icon={AccountBox}
        required
        minLength={0}
        maxLength={20}
        errorMessage='Campo requerido'
        name={'lastName'}
        onChange={handleChange}
        newValue={formData.lastName}
      />
      <TextBox
        label={'Número de teléfono'}
        icon={Phone}
        type='number'
        required
        minLength={0}
        maxLength={8}
        errorMessage='Campo requerido'
        name={'phone'}
        newValue={formData.phone}
        onChange={handleChange}
      />
      <TextBox
        label={'Puesto'}
        icon={AccountTree}
        type='text'
        required
        minLength={0}
        maxLength={20}
        errorMessage='Campo requerido'
        name={'role'}
        newValue={formData.role}
        onChange={handleChange}
      />
      <TextBox
        label={'Email'}
        icon={Mail}
        type='email'
        name={'email'}
        newValue={formData.email}
        onChange={handleChange}
      />
      <CustomAutoComplete name={"supplier_id"} onChange={handleChange} supplier={formData.supplier_id}/>
      <Stack spacing={2} direction={"row"}>
      <ButtonSubmit name='Actualizar' icon={Add} loading={loading}/>
      <ButtonBack/>
      </Stack>
      {openSnack && (
        <CustomSnackBar open={openSnack} setOpen={setOpenSnack} message={snackMessage} severity={snackSeverity} />
      )}
    </form>
  );
}
